import { NavigateToResource, NavigateToResourceOptions } from '..';
import { RouteDtoModelType } from '../../models';
import { SchedulingQueryParams } from '../constants';
import { QueryParamsToReplace } from './validateQueryParams';

export const navigateToRouteResourceParams = (
  currentParams: URLSearchParams,
  resource: NavigateToResource,
  options?: NavigateToResourceOptions,
  targetRoute?: RouteDtoModelType,
) => {
  const { routeUuid, stopUuid, orderUuid } = resource;
  const { deselectRoute, deselectStop, deselectOrder } = options || {};
  const queryParams: QueryParamsToReplace = {};

  if (currentParams.get(SchedulingQueryParams.ROUTE) && deselectRoute) {
    queryParams[SchedulingQueryParams.ROUTE] = null;
  }

  if (currentParams.get(SchedulingQueryParams.STOP) && deselectStop) {
    queryParams[SchedulingQueryParams.STOP] = null;
  }

  if (currentParams.get(SchedulingQueryParams.ORDER) && deselectOrder) {
    queryParams[SchedulingQueryParams.ORDER] = null;
  }

  if (routeUuid) {
    queryParams[SchedulingQueryParams.ROUTE] = routeUuid;
    queryParams[SchedulingQueryParams.DATE] = targetRoute?.startDate || '';
  }

  if (stopUuid) {
    queryParams[SchedulingQueryParams.STOP] = stopUuid;
  }

  if (orderUuid) {
    queryParams[SchedulingQueryParams.ORDER] = orderUuid;
  }

  return queryParams;
};
